// extracted by mini-css-extract-plugin
export default {"wrapper":"TopPanel_wrapper__VzTsV","profile":"TopPanel_profile__xHMWi","text":"TopPanel_text__MvBgW","logo":"TopPanel_logo__400Vx"};